import LogsPage from '../Pages/LogsPage';
import {  useAppSelector } from '../Modules/Presentation/hooks';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { selectUser } from '../Modules/User/Presentation/selectors';
const LogsRoutes = () => {

    const navigate = useNavigate();
  const currentUser = useAppSelector(selectUser);
    if (currentUser?.grade === 'SELLER') {
    return (
      <Result
        status="403"
        title="접근 권한이 없습니다"
        subTitle="이 페이지는 셀러 계정으로 접근할 수 없습니다."
        extra={
          <Button
            type="primary"
            size="large"
            style={{ borderRadius: 6, padding: '0 32px' }}
            onClick={() => navigate('/')}
          >
            홈으로 이동
          </Button>
        }
      />
    );
  }

  return (
    <LogsPage />
  );
}
export default LogsRoutes;
